import { makeAutoObservable } from 'mobx';
import { SelectedWorkingHourToPay } from '../../pages/salaries/salary-generator/salaries-generator-page';
import { UserSummaryType } from '../../api/types/user/user-summary.type';

class GlobalSalaryStore {
  private _selectedWorkingHourToPay: SelectedWorkingHourToPay[] = [];
  private _user: UserSummaryType | null = null;
  constructor() {
    makeAutoObservable(this, {}, { deep: true }); // Just add deep: true
  }

  get selectedWorkingHourToPay(): SelectedWorkingHourToPay[] {
    return this._selectedWorkingHourToPay;
  }

  set selectedWorkingHourToPay(value: SelectedWorkingHourToPay[]) {
    this._selectedWorkingHourToPay = value;
  }

  get user(): UserSummaryType | null {
    return this._user;
  }

  set user(value: UserSummaryType | null) {
    this._user = value;
  }
}

const globalSalaryStore = new GlobalSalaryStore();
export default globalSalaryStore;
